import React from 'react';
import PropTypes from 'prop-types';

import Table from '../Table';

const MAX_PRODUCTS_SHOWN = 6;

export default class ListGraph extends React.Component {
	static propTypes = {
		data: PropTypes.object
	};

	state = {
		expanded: false
	};

	renderViewMore(rowsLength, expanded) {
		if (rowsLength <= MAX_PRODUCTS_SHOWN) {
			return null;
		}

		return (
			<span className="list-expander" onClick={() => this.setState({ expanded: !expanded })}>
				{expanded ? 'View less' : 'View more'}
			</span>
		);
	}

	render() {
		const { expanded } = this.state;
		const { data } = this.props.data;
		let [header, rows] = data;

		return (
			<div className="listgraph">
				<Table
					selectable={false}
					loading={!rows.length}
					data={rows}
					defaultSort={1}
					defaultSortAsc={false}
					perPage={expanded ? 1000 : MAX_PRODUCTS_SHOWN}
					fields={header.map((item, index) => ({
						title: item,
						sortable: true,
						sort: (row) => row[index],
						formatter: (row) =>
							typeof row[index] === 'object' ? (
								<a href={row[index][1]} rel="noopener noreferrer" target="_blank">
									{row[index][0]}
								</a>
							) : (
								row[index]
							)
					}))}
				/>
				{this.renderViewMore(rows.length, expanded)}
			</div>
		);
	}
}
